const AvatarIcon = () => {
  return (
    <img className="margin_5" src="/images/avatar-icon.svg" />
  )
}

export default AvatarIcon
